// Components
import Hero from "./Hero";
import HeroImageGrid from "./HeroImageGrid";
// Types
import { Locale } from "../../../helpers/localization";

const HeroWrapper: React.FC<{ deviceLanguage: Locale }> = ({
  deviceLanguage,
}) => {
  return (
    <div className="hero-wrapper">
      <Hero deviceLanguage={deviceLanguage} />
      <HeroImageGrid />
    </div>
  );
};

export default HeroWrapper;
